import { render, staticRenderFns } from "./ModalCadastrarConta.vue?vue&type=template&id=37a588ee&scoped=true&"
import script from "./ModalCadastrarConta.vue?vue&type=script&lang=js&"
export * from "./ModalCadastrarConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a588ee",
  null
  
)

export default component.exports